export default __webpack_public_path__ + "static/media/020-snow.07bf8fd0.svg";